import React, { useState } from 'react'
import styled from 'styled-components'
import { DotsIcon, EditIcon, TrashIcon } from '@mote/assets/icons'
import { Dropdown } from '@mote/ui'

export const Options = ({ moteId = '', onEdit, onDelete, ...rest }) => {
  function handleSelection(key) {
    switch (key) {
      case 'edit-mote': {
        onEdit?.()
        break
      }
      case 'delete-mote': {
        onDelete?.()
        break
      }
      default:
      // no-op
    }
  }

  return (
    <StyledDropdown
      id={`mote-player-options-${moteId}`}
      onAction={handleSelection}
      triggerElementContent={<DotsIcon color='currentColor' height={14} />}
      placement='bottom-right'
      showChevron={false}
      aria-label='Mote options'
      {...rest}
    >
      {onEdit && (
        <Option key='edit-mote'>
          <EditIcon color='currentColor' />
          <InnerText>Edit</InnerText>
        </Option>
      )}
      {onDelete && (
        <Option key='delete-mote'>
          <TrashIcon color='currentColor' />
          <InnerText>Delete</InnerText>
        </Option>
      )}
    </StyledDropdown>
  )
}

const StyledDropdown = styled(Dropdown)`
  .dropdown-trigger-container {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    color: #646f7b;
    padding: 0;
  }

  .dropdown-container {
    width: max-content;
    padding: 4px 0 !important;
    margin: 0 !important;
    margin-top: 5px !important;
  }
`

const Option = styled(Dropdown.Item)`
  font-size: 14px;
  line-height: 32px;
  height: 32px;

  svg {
    width: 1.3125em;
    height: 1.3125em;
  }
`

const InnerText = styled(Dropdown.ItemText)``

Options.Option = Option
Options.Text = InnerText
